<template>
  <v-alert
    prominent
    type="error"
  >
    <v-row align="center">
      <v-col class="grow">
        {{ value.message }}
      </v-col>
      <v-col class="shrink">
        <v-btn
          text
          v-on:click="$emit('retry')"
        >{{ retryText || 'Retry' }}</v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
export default {
  props: {
    value: [Error, Object],
    retryText: {
      type: String,
      default: undefined,
    },
  },
}
</script>